/**
 * Hub API base URL resolver (legacy platform integration).
 *
 * Standalone deployments run WITHOUT a Hub: when no hub URL is configured,
 * `HUB_API_BASE` is empty and `isHubConfigured` is false — consumers must
 * skip Hub calls entirely and use built-in defaults (e.g. NavHeader falls
 * back to the module's own /api/organizations/:id/brand endpoint).
 *
 * Resolution order:
 *   1. rc.hubApiUrl   — explicit hub-api URL (server/src/module.ts injection)
 *   2. rc.hubUrl      — legacy field used by main.tsx for MSAL config
 *   3. VITE_HUB_API_URL — compile-time build env for dev or static builds
 *   4. ''             — no Hub (standalone default)
 */
const rc = (window as unknown as {
	__CONTRACTACIO_CONFIG__?: { hubApiUrl?: string; hubUrl?: string }
}).__CONTRACTACIO_CONFIG__

export const HUB_API_BASE: string =
	rc?.hubApiUrl || rc?.hubUrl || import.meta.env.VITE_HUB_API_URL || ""

/** True only when a Hub base URL is configured — never call Hub endpoints otherwise. */
export const isHubConfigured: boolean = HUB_API_BASE !== ""
